import React from "react";
import PropTypes from "prop-types";
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  Dialog,
  Button,
  LinearProgress,
  Card,
  CardHeader,
  CardContent,
  Typography
} from "@material-ui/core";
import { Row, Col } from "react-flexbox-grid/lib/index";

import Inspector from "react-json-inspector";

const RecallToDeviceResultModal = props => {
  /*

  {
  "status": "success",
  "namespace": "http://www.devicemagic.com/xforms/14da1d20-cd2f-0133-14bd-22000bc00064?38cad760-2ddf-0135-ce8f-22000a1ed9c7",
  "form_name": "2017-06-05 Zooplankton Lab - fgbvun27ka (recalled)"
  }

*/
  let result = "";

  if ("status" in props.recallDeviceResponse) {
    const deviceIndex = props.devices
      .map(d => d.identifier)
      .indexOf(props.recallDeviceResponse.device_identifier);
    if (props.recallDeviceResponse.status === "success") {
      result = (
        <div>
          <Typography>
            Recalled form: <b>{props.recallDeviceResponse.form_name}</b>
          </Typography>
          <Typography>
            To device:{" "}
            <b>
              {props.devices[deviceIndex].name ||
                props.devices[deviceIndex].email}
            </b>
          </Typography>
        </div>
      );
    } else {
      result = (
        <div>
          <Typography>
            <b>Error: {props.recallDeviceResponse.message}</b>
          </Typography>
        </div>
      );
    }
  }

  return (
    <Dialog
      open={props.isRecallToDeviceStatusModalOpen}
      fullWidth
      max-width="xl"
      modal
    >
      <DialogTitle>Recall to Device</DialogTitle>
      <DialogContent>
        <Row>
          <Col xs={12}>
            {props.isRecallingToDevice ? <LinearProgress /> : result}
          </Col>
        </Row>

        {!props.isRecallingToDevice ? (
          <Row>
            <Col xs={11}>
              <Card>
                <CardHeader
                  title="View Response"
                  actAsExpander
                  showExpandableButton
                />
                <CardContent expandable>
                  <Inspector search={false} data={props.recallDeviceResponse} />
                </CardContent>
              </Card>
            </Col>
          </Row>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button primary onClick={props.onRecallConfirmationCloseClick}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RecallToDeviceResultModal.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      identifier: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  recallDeviceResponse: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.string,
    device_identifier: PropTypes.string,
    form_name: PropTypes.string
  }).isRequired,
  onRecallConfirmationCloseClick: PropTypes.func.isRequired,
  isRecallToDeviceStatusModalOpen: PropTypes.bool.isRequired,
  isRecallingToDevice: PropTypes.bool.isRequired
};

export default RecallToDeviceResultModal;
